import { action, makeObservable } from 'mobx'
import ContactInfoEditorViewModel from '../../editors/ContactInfoEditorViewModel'
import BusinessInfoEditorViewModel from './BusinessInfoEditorViewModel'
import { BusinessProfileVersion } from '../BusinessProfileVersion'

export default class BusinessProfileEditorViewModel {
  readonly businessInfoVm = new BusinessInfoEditorViewModel()

  readonly contactInfoVm = new ContactInfoEditorViewModel()

  constructor() {
    makeObservable(this)
  }

  @action.bound
  validate() {
    const businessValid = this.businessInfoVm.validate()
    const contactValid = this.contactInfoVm.validate()
    return businessValid && contactValid
  }

  @action.bound
  reset(profile?: BusinessProfileVersion | null) {
    const businessInfo = profile?.businessInfo
    this.businessInfoVm.reset(
      businessInfo
        ? {
            businessName: businessInfo.businessName,
            dateOfIncorporation: businessInfo.dateOfIncorporation,
            employerIdentificationNumber:
              businessInfo.employerIdentificationNumber,
          }
        : undefined,
    )

    const contactInfo = profile?.contactInfo
    this.contactInfoVm.reset(
      contactInfo
        ? {
            email: contactInfo.email,
            phoneNumber: contactInfo.phoneNumber,
            address: {
              addressLine1: contactInfo.addressLine1,
              addressLine2: contactInfo.addressLine2,
              city: contactInfo.city,
              region: contactInfo.region,
              postalCode: contactInfo.postalCode,
              country: contactInfo.country,
            },
          }
        : undefined,
    )
  }
}
